<template>
  <section>
    <div class="flex flex-wrap items-start justify-center m-auto mb-3" ref="formWrapper" :class="isTwoColumnLayout ? 'md:max-w-xl' : 'md:max-w-lg'">
      <vpf-input
        @inputWasChanged="handleErrors($event, index)"
        v-for="(input, index) in $store.state.data.Steps[
          $store.state.activeStep
        ].Form"
        :key="input.Label"
        :type="input.FieldType || 'text'"
        :placeholder="input.Placeholder"
        :is-required="input.Required"
        :label="input.Label"
        :error-message="input.ErrorMessage"
        :name="input.Name"
        :id="input.Id"
        :value="$store.state.userInputs[input.SalesforcePropertyKey]"
        @input="updateInput($event, input.SalesforcePropertyKey)"
        :ref="input.FieldType === 'input' 
           || input.FieldType === 'email' 
           || input.FieldType === 'text' 
           || input.FieldType === 'textarea' 
           || input.FieldType === 'tel' 
           ? 'textInput' : null"
      />
    </div>
    <div class="flex items-center justify-evenly flex-col md:max-w-3xl m-auto">
      <vpf-button
        class=""
        :is-disabled="form.isInvalid"
        @click.native="setNextStep()"
      >
        {{ $store.state.data.Steps[$store.state.activeStep].ButtonTextNext }}
      </vpf-button>
    </div>
  </section>
</template>

<script>
import Button from "../shared/Button";
import Input from "../shared/Input";

import { mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {
      form: {
        errors: [],
        isInvalid: true
      },
      currentActiveStepId: null,
      isTwoColumnLayout: false
    };
  },
  components: {
    "vpf-button": Button,
    "vpf-input": Input
  },
  watch: {
    getActiveStepId: function () {
        this.form.errors = [];

        if(window.proForm && window.proForm.twoColumnLayouts && window.proForm.twoColumnLayouts[this.getActiveStepId]) {
          this.isTwoColumnLayout = window.proForm.twoColumnLayouts[this.getActiveStepId];
        }
    }
  },
  updated() {
    // Need to set the input focus this way because watching the active step id occurs too soon
    // We need to adjust the input focus on step change also when the next step is using a form template still meaning the mounted hook won't fire
    if (this.currentActiveStepId !== this.getActiveStepId) {
      this.updateStep();
    }
  },
  mounted() {
    this.updateStep();
  },
  computed: {
    ...mapGetters([
      "getActiveStepId"
    ]),
  },
  methods: {
    ...mapMutations([
      "updateUserInput",
      "nextStep"
    ]),
    updateStep() {
      if (this.$refs.textInput !== undefined && this.$refs.textInput.length > 0) this.$refs.textInput[0].$refs.focusInput.focus();
      this.currentActiveStepId = this.getActiveStepId;      
    },
    handleErrors(e, index) {
      this.form.errors[index] = e;
      this.setValidity();
    },
    setValidity() {
      this.form.isInvalid =
        this.form.errors.includes(true) || this.form.errors.length === 0;
    },
    setNextStep() {
      //  If this is the step where we collect data -  Email, Phone and Leagal staff
      //  we need to check if next step is a success step or not.
      //  If Yes - we show success and execute API call to SalesForce
      //  If No - we need to show next step where usually we select time and date
      if (this.$store.state.activeFlow) {
        const flowSteps =
          this.$store.state.data.Flows[this.$store.state.activeFlow];

        if (flowSteps[this.$store.state.currentActiveIndex + 1]) {
          const flowId = flowSteps[this.$store.state.currentActiveIndex + 1];

          if (flowId) {
            if (this.$store.state.data.Steps[flowId].Name === "Step_Success") {
              // execute API
              // console.log("call API");
              this.$store.dispatch("salesForceIntegration").then(response => {
                if (response) {
                  this.nextStep();
                } else {
                  console.warn("Error in response");
                }
              });
            } else {
              // show Next step
              this.nextStep();
            }
          }
        }
      } else {
        this.nextStep();
      }
    },
    updateInput(e, name) {
      let inputValue = typeof e === 'boolean' ? e : e.target.value.trim() || '';

      if (name) {
        this.updateUserInput({ [name]: inputValue });
      }
    }
  }
};
</script>
